<template>
<div>

    <div class="register-box" v-if="active == 1">
        <p class="title">注册数企账号</p>
        <van-form @submit="nextStep" ref="firstForm">
             <van-field name="phone"  placeholder="手机号" v-model="phone" :rules="[{ required: true, message: '请填写手机号'}, {validator:(value)=>{return /^1[3456789]\d{9}$/.test(value.replace(/\s*/g,'')) },message: '手机号格式错误'}]"/>
             <van-field name="picCode" placeholder="请输入图形码" maxlength="10" v-model="picCode" :rules="[{ required: true, message: '请填写图形验证码'}]">
                <verification-code slot="button" ref="verificationCode" class="verification-code" :trigger="trigger" />
             </van-field>
             <van-field name="authCode" placeholder="请输入短信验证码" maxlength="10" v-model="authCode" :rules="[{ required: true, message: '请填写短信验证码'}]">
                <sms-code slot="button" class="sms-code" :count-down="30" @send="sendSMS" ></sms-code>
             </van-field>
             <van-checkbox v-model="checkboxStatus" :label-disabled="true" style="margin: 24px auto 34px">
                我已同意并接受
                <a class="blod-text" href="https://vip.bdsaas.com/pages/store/user-agreement.html?id=1" target="_blank">数企用户协议</a>
                和
                <a class="blod-text" href="https://vip.bdsaas.com/pages/store/user-agreement.html?id=2" target="_blank">隐私政策</a>
             </van-checkbox>
             <div>
                <van-button round block type="info" native-type="submit" :disabled="checkboxStatus != 1">下一步</van-button>
             </div>
        </van-form>
    </div>
    <div class="register-box" v-if="active == 2">
        <p class="title">注册数企账号</p>
        <van-form @submit="nextStep" ref="secondForm">
             <van-field name="用户名" placeholder="请输入您的姓名" maxlength="10" v-model="username" :rules="[{ required: true, message: '请填写您的姓名'}, {validator:(value)=>{return value.length > 1 }, message: '姓名不小于2位'}]"/>
             <van-field type="password" name="密码" maxlength="20" placeholder="请设置密码" v-model="password" :rules="[{ required: true, message: '请填写密码'}, {validator:(value)=>{return value.length > 5 },  message: '密码长度不小于6位'}]"/>
             <van-field type="password" name="密码" maxlength="20" placeholder="请确认密码" v-model="repassword" :rules="[{ required: true, message: '请填写确认密码'},, {validator:(value)=>{return value.length > 5 },  message: '密码长度不小于6位'},{ validator:(value)=>{return value == password}, message: '两次密码不一致'}]"/>
             <div>
                <van-button round block type="info" native-type="submit" style="margin:34px auto 0">完成</van-button>
             </div>
        </van-form>
    </div>
    <div class="register-box" style="padding:0 38px" v-if="active == 3">
        <img src="@/assets/img/avator.svg" alt="" class="avator-img">
        <p class="f-title">Hi,{{username}}</p>
        <p class="f-subtitle">您已成功注册数企账号</p>
        <p class="f-subtitle">可复制链接，前往PC端体验免费版本哦~</p>
        <p class="f-subtitle zombie" style="font-family: Montserrat-Medium, Montserrat;">https://vip.bdsaas.com</p>
        <van-button round block type="info" native-type="submit" class="button1" @click="copy">复制链接</van-button>
        <van-button round block type="info" native-type="submit" class="button2" @click="downLoad">下载数企APP</van-button>
    </div>
</div>

</template>

<script>
import head from '@/mixins/head';
import VerificationCode from './components/VerificationCode';
import SmsCode from './components/SmsCode';
import qs from 'qs';
export default {
    mixins: [ head ],
    components: {
        VerificationCode,
        SmsCode
    },
    data() {
        return {
            active: 1,
            phone: '',
            picCode: '',
            authCode: '',
            checkboxStatus: false,
            username: '',
            password: '',
            repassword: '',
            trigger: false
        };
    },
    computed: {
        mobile() {
            return this.phone.replace(/\s*/g, '');
        }
    },
    watch: {
        phone(val) {
            let temPhone = val.replace(/\s*/g, '');
            let a = temPhone.slice(0, 3);
            let b = temPhone.slice(3, 7);
            let c = temPhone.slice(7, 11);
            this.phone = (a + ' ' + b + ' ' + c).trim();
        }
    },
    methods: {
        async sendSMS(next) {
            this.$refs.firstForm.validate(['phone', 'picCode'])
            .then(() => {
                this.$httpAxios
                .post('bdsaas/ajax/main/yanzheng.do', { mobile: this.mobile, code: this.picCode }, {
                    noToken: true,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    transformRequest: [function (data) {
                        data = qs.stringify(data);
                        return data;
                    }]
                }).then((res) => {
                    if (res.data.rspCode != 0) {
                        this.trigger = !this.trigger;
                        this.$toast.fail({
                            duration: 2000,
                            forbidClick: true,
                            message: res.data.rspMsg
                        });
                    } else {
                        next();
                    }
                })
                .catch(() => {

                });
            })
            .catch(() => {

            });
        },
        openAgreement() {

        },
        openPolicy() {

        },
        validateSMS() {
            this.$refs.firstForm.validate().then(res => {
                this.$httpAxios
                .post('bdsaas/ajax/profile/checkSms.do', { mobile: this.mobile, checkCode: this.authCode }, {
                    noToken: true,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    transformRequest: [function (data) {
                        data = qs.stringify(data);
                        return data;
                    }]
                }).then((res) => {
                    if (res.data.rspCode != 0) {
                       this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: res.data.rspMsg
                        });
                    } else {
                        this.active = 2;
                    }
                })
                .catch(() => {

                });
            });
        },
        register() {
            this.$refs.secondForm.validate().then(res => {
                let params = {
                    mobile: this.mobile,
                    realName: this.username,
                    yanzheng: this.authCode,
                    password: this.password,
                    repassword: this.repassword,
                    terminaltype: 'WEB'
                };
                this.$httpAxios.post('bdsaas/ajax/main/register.do', params, {
                    noToken: true,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    transformRequest: [function (data) {
                        data = qs.stringify(data);
                        return data;
                    }]
                }).then(res => {
                    if (res.data.rspCode != 0) {

                    } else {
                        this.active = 3;
                    }
                });
            });
        },
        nextStep() {
            if (this.active === 1) {
                if (this.checkboxStatus) {
                    this.validateSMS(this.phone, this.picCode);
                }
            } else if (this.active === 2) {
                this.register();
            }
        },
        copy() {
            var input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', 'https://vip.bdsaas.com');
            input.select();
            if (document.execCommand('copy')) {
                this.$toast.success({ message: '已复制到剪切板' });
            } else {
                this.$toast.fail({ message: '该浏览器不支持自动复制' });
            }
            document.body.removeChild(input);
        },
        downLoad() {
            window.location.href = 'https://www.bdsaas.com/download.html';
        }
    }
};
</script>

<style lang="scss" scoped>
.verification-code{
    // width: 89px;
    height: 50px;
    padding: 2px;
    position: absolute;
    right: 11px;
    top: 0;
}
.sms-code{
    height: 50px;
    position: absolute;
    right: 18px;
    top: 0;
}
.van-cell{
    padding: 7px 0;
    &.van-field--error{
        /deep/.van-field__body{
            input{
                border: 2px solid #F12525 !important;
            }
        }
    }
    /deep/.van-field__control{
        flex-shrink: 0;
    }
}
.argee-item{
    margin: 24px auto 34px;
}
.blod-text{
    color: #212325;
    margin: 0 6px;
}
.register-box{
    .title{
        height: 24px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212325;
        line-height: 24px;
        margin: 100px 0 34px 0;
    }
    /deep/.van-cell::after{
        border: none;
    }
    /deep/.van-form{
        padding: 0 25px;
        position: relative;
        input{
            height: 50px;
            background: #F5F7FB;
            border-radius: 10px;
            padding-left: 18px;
            font-size: 16px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #212325;
            border: 2px solid #F5F7FB;
            &::placeholder{
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9CA6B9;
            }
            &:focus{
                box-shadow: 0px 2px 20px 0px rgba(33,35,37,0.1);
                border: 2px solid #0056FF;
            }
        }
        .van-field__error-message{
            height: 13px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #F12525;
            line-height: 13px;
            margin-top: 10px;
        }
        .van-checkbox__label{
            height: 13px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9CA6B9;
            line-height: 13px;
        }
        .van-button{
            height: 50px;
            background: #0056FF;
            border-radius: 25px;
            border: none;
            margin: auto;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            &.van-button--disabled{
                background: #CCDEFF;
            }
        }
    }
    .avator-img{
        margin: 100px auto 30px;
        width: 80px;
        height: 80px;
    }
    .f-title{
        margin: 30px auto 18px;
        height: 34px;
        font-size: 34px;
        font-family: Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #242934;
        line-height: 34px;
    }
    .f-subtitle{
        margin: 10px auto;
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9CA6B9;
        line-height: 16px;
    }
    .button1{
        margin: 40px 0 20px;
        height: 50px;
        background: #0056FF;
        border-radius: 25px;
        border: none;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }
    .button2{
        height: 50px;
        background: #F2F6FF;
        border-radius: 25px;
        border: none;
        font-size: 16px;
        font-family: Montserrat-Medium, Montserrat;
        font-weight: 500;
        color: #0056FF;
        margin: 20px 0 0;
    }
}
</style>
